import { syncHistoryWithStore } from "mobx-react-router";
import { createBrowserHistory } from "history";
import routing from "../stores/routing";

const browserHistory = createBrowserHistory();
export const history = syncHistoryWithStore(browserHistory, routing);
